import { ProductRequest } from '@/lib/submit/send-product-request';
import { AssistantSubmitStepContext } from '~/steps/submit';
import { StepCategoryId } from '~/consts/assistant-steps';

export const getProductRequest = (
  formData: AssistantSubmitStepContext,
  comment: string,
  productId: string,
  productType: string | null,
  assistantData: Record<string, unknown>,
  salutation?: 'Herr' | 'Frau' | 'Keine Angabe',
): ProductRequest => ({
  city: formData.city,
  comment,
  email: formData.email,
  firstName: formData.firstname,
  lastName: formData.lastname,
  phone: formData.phone,
  productId,
  requestType: productType,
  productUrl: `${process.env.VUE_APP_STAWAG_HOST}/detail/${productId}`,
  salutationDisplayName: salutation ?? 'Keine Angabe',
  street: `${formData.street} ${formData.streetNumber}`,
  zipCode: formData.zipcode,
  assistantData,
});

export const getProductId = (category: StepCategoryId) => {
  switch (category) {
    case StepCategoryId.HEATING:
      return process.env.VUE_APP_SHOP_PRODUCT_ID_HEATING;
    case StepCategoryId.EMOBILITY:
      return process.env.VUE_APP_SHOP_PRODUCT_ID_EMOBILITY;
    case StepCategoryId.SOLAR:
      return process.env.VUE_APP_SHOP_PRODUCT_ID_SOLAR;
    case StepCategoryId.COMBI:
      return process.env.VUE_APP_SHOP_PRODUCT_ID_COMBI;
  }

  return process.env.VUE_APP_SHOP_PRODUCT_ID;
};

export const getProductType = (category: StepCategoryId) => {
  switch (category) {
    case StepCategoryId.HEATING:
      return process.env.VUE_APP_SHOP_PRODUCT_TYPE_HEATING;
    case StepCategoryId.EMOBILITY:
      return process.env.VUE_APP_SHOP_PRODUCT_TYPE_EMOBILITY;
    case StepCategoryId.SOLAR:
      return process.env.VUE_APP_SHOP_PRODUCT_TYPE_SOLAR;
    case StepCategoryId.COMBI:
      return process.env.VUE_APP_SHOP_PRODUCT_TYPE_COMBI;
  }

  return null;
};
